// Synced from heivol KB design-system/site-header-react/ — edit the canon first, then re-sync (see design-system/site-header.md).
import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { getTheme, toggleTheme } from '../lib/theme';

type Props = {
  /**
   * Optional right-aligned slot rendered before the theme toggle — app-shell
   * controls (LockBadge, Lock now, logout pill) on the authenticated portal.
   */
  rightSlot?: ReactNode;
};

// Locker adaptation of the canon: the marketing-nav branch (`showNav`) is dropped
// — the zero-knowledge portal is always post-auth and never shows marketing nav,
// and locker's CSS contract block ships no `.site-nav` styles. Right cluster is
// Variant B (app-shell) only. Re-sync note: re-apply this trim after pulling canon.
export function SiteHeader({ rightSlot }: Props) {
  const [theme, setLocalTheme] = useState(getTheme());

  useEffect(() => {
    setLocalTheme(getTheme());
  }, []);

  function handleToggle() {
    setLocalTheme(toggleTheme());
  }

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a href="https://heivol.com/" className="brand" aria-label="Heivol home">
          <svg
            className="brand__mark"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1024 1024"
          >
            <g fill="currentColor">
              <rect x="234" y="299" width="89" height="384" />
              <rect x="234" y="446" width="298" height="76" />
              <rect x="442" y="299" width="89" height="384" />
              <polygon points="714,299 820,299 616,683 503,683" />
            </g>
          </svg>
          <span className="brand__name">Heivol</span>
          <span className="brand__product">Locker</span>
        </a>

        <div className="site-header__right ml-auto">
          {rightSlot}
          <button
            id="theme-toggle"
            className="theme-toggle"
            type="button"
            aria-label="Toggle dark mode"
            aria-pressed={theme === 'dark'}
            onClick={handleToggle}
          >
            <span className="theme-toggle__icon" aria-hidden="true">
              ◐
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
